/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:41:57
 * @LastEditors: heyuan
 * @LastEditTime: 2020-08-19 17:44:26
 * @FilePath: \program-name\src\net\home\index.js
 */
import {get,post} from "../Api.js";
import config from "../config";
const {baseUrl} = config

  // 根据uid和试卷id获取练习题列表
  function ApiGetPQList(params) {
    return post(`${baseUrl}course/practiceDetail`, params);
  }

  // 根据uid和分类id获取专项练习题列表
  function ApiGetSQList(params) {
    return post(`${baseUrl}practice/mockPracticeQuestions`, params);
  }

 // 根据uid获取错题列表
 function ApiGetWQList(params) {
   return post(`${baseUrl}student/wrongQuestionIds`, params);
 }

  // 根据题号获取练习的试题
  function ApiGetPQuestion(params) {
    return post(`${baseUrl}course/practiceQuestion`, params);
  }

  // 根据题号获取错题本的试题
  function ApiGetWQuestion(params) {
    return post(`${baseUrl}student/wrongPracticeQuestion`, params);
  }

 // 提交练习题的结果
 function ApiSavePractice(params) {
   return post(`${baseUrl}course/savePractice`, params);
 }

 // 提交错题本答题的结果
 function ApiSaveWrong(params) {
   return post(`${baseUrl}student/saveWrongQuestion`, params);
 }

 // 获取试题解析
 function ApiGetAnalysis(params) {
   return post(`${baseUrl}course/questionAnalysis`, params);
 }


 // 获取考试试题列表
 function ApiGetExamQuestions(params) {
	 return post(`${baseUrl}exam/examQuestions`, params);
 }
 // 获取考试试题详情
 function ApiGetEQDetail(params) {
 	 return post(`${baseUrl}exam/questionDetail`, params);
 }
 // 考试提交
 function ApiSaveExamResult(params) {
 	 return post(`${baseUrl}exam/saveExamResult`, params);
 }
 // 获取考试结果
 function ApiGetExamResult(params) {
 	 return post(`${baseUrl}exam/examResult`, params);
 }

 // 获取专项练习列表
 function ApiGetCategory(params) {
 	 return get(`${baseUrl}practice/category`, params);
 }
 // 获取模拟考试列表
 function ApiGetMockExam(params) {
 	 return post(`${baseUrl}practice/mockExam`, params);
 }
 // 获取模拟考试详情
 function ApiGetMockExamInfo(params) {
 	 return post(`${baseUrl}practice/mockExamInfo`, params);
 }
 // 获取考试详情
 function ApiGetExamInfo(params) {
 	 return post(`${baseUrl}task/examInfo`, params);
 }
  export {
    ApiGetPQList,
    ApiGetSQList,
    ApiGetWQList,
    ApiGetPQuestion,
    ApiGetWQuestion,
    ApiSavePractice,
    ApiSaveWrong,
    ApiGetAnalysis,
		ApiGetExamQuestions,
    ApiGetEQDetail,
    ApiSaveExamResult,
    ApiGetExamResult,
    ApiGetCategory,
    ApiGetMockExam,
    ApiGetMockExamInfo,
    ApiGetExamInfo
  }



// WEBPACK FOOTER //
// ./src/net/exam/index.js